// Ionic Angular
import { Directive } from '@angular/core'


@Directive({
    selector: '[tidyLink]',
    standalone: false
})
export class TidyLinkDirective { }
